import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "help-doc" }
const _hoisted_2 = { class: "help-doc-header" }
const _hoisted_3 = { class: "doc-header-left" }
const _hoisted_4 = { class: "help-doc-main" }
const _hoisted_5 = { class: "iframe-container" }
const _hoisted_6 = {
  key: 0,
  class: "loading"
}

import { ref } from 'vue'
import { ArrowLeft } from '@element-plus/icons-vue'
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'indexDoc',
  setup(__props) {

const loading = ref(true)

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_spinner = _resolveComponent("el-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: "back-btn",
          link: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft))
              ]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createTextVNode(" 返回 "))
          ]),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "doc-header-right" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "公司logo",
          class: "company-logo"
        })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_spinner, { size: "large" }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "文档加载中...", -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("iframe", {
          onLoad: _cache[1] || (_cache[1] = ($event: any) => (loading.value = false)),
          src: "https://ecn20utu2ny9.feishu.cn/docx/RV1ydXmaTorQ4ixb7AUcJOeOn8c?from=from_copylink",
          frameborder: "0",
          width: "100%",
          height: "100%",
          allowfullscreen: ""
        }, null, 32)
      ])
    ])
  ]))
}
}

})